
<div
  *ngIf="locked$ | async"
  class="locked-banner"
  role="alert"
  @fade>
  <strong>Your account is locked.</strong>
  Please visit <a routerLink="/user/account">My Account</a> and update your credit card information to unlock your subscription.
</div>
